import React, { useEffect, useState } from 'react';
import { getFirebaseLiveData } from '../../../Utils/firebaseLiveData';
import { getMonthName } from '../../../Utils/helper';
// import {
//     getValues,
//     updateValuesInFireBaseDB,
// } from "../../../Utils/firebaseLiveData";
import { ArticleDetailSection, Flex, Tag, Views, WrittenDate } from './styled';

export default function ArticleDetail(props) {
  const { data, video, selctedLanguage } = props;
  const viewsValueData = async () => {
    const { getValues, updateValuesInFireBaseDB } = getFirebaseLiveData();
    const updatedData = await getValues('Views/OwnArticle/', data?.id);
    if (updatedData?.views) {
      const obj = {
        [`Views/OwnArticle/${data?.id}/views`]: updatedData?.views + 1,
      };
      updateValuesInFireBaseDB(obj);
    }
    if (updatedData?.views || updatedData?.views == 0) {
      updatedData.views = updatedData?.views + 1;
      setViewsData(updatedData);
    }
  };

  const [viewsData, setViewsData] = useState({});
  const getDate = (date) => {
    var dateObj = new Date(date);
    var month = dateObj.getUTCMonth() + 1; //months from 1-12
    var day = dateObj.getUTCDate();
    var year = dateObj.getUTCFullYear();
    let newdate = `${day} ${getMonthName(month)} ${year}`;
    return newdate;
  };
  useEffect(() => {
    viewsValueData();
  }, [data?.id]);

  // useEffect(() => {
  //     if (viewsData?.views) {
  //         const obj = {
  //             [`Views/OwnArticle/${data?.id}/views`]: viewsData?.views + 1,
  //         };
  //         updateValuesInFireBaseDB(obj);
  //     }
  // }, [viewsData?.views]);
  const getWrittenOnText = (selectedLanguage) => {
    const updatedAt = data?.updated_at;
    switch (selectedLanguage) {
      case 'hi':
        return (
          <WrittenDate>{getDate(updatedAt)} को अपडेट किया गया</WrittenDate>
        );
      case 'bn':
        return <WrittenDate>{getDate(updatedAt)} আপডেট করা হয়েছে</WrittenDate>;
      case 'ta':
        return (
          <WrittenDate>
            {getDate(updatedAt)} அன்று புதுப்பிக்கப்பட்டது
          </WrittenDate>
        );
      case 'te':
        return <WrittenDate>{getDate(updatedAt)} న నవీకరించబడింది</WrittenDate>;
      default:
        return <WrittenDate>Updated on {getDate(updatedAt)}</WrittenDate>;
    }
  };

  return (
    <ArticleDetailSection>
      <Flex height="22px">
        <Tag>{data?.tagsWithId[0]?.description}</Tag>
        {viewsData?.views && !video ? (
          <Flex>
            <img src="/images/views_eye.svg" alt="views icons" />
            <Views>{viewsData?.views}</Views>
          </Flex>
        ) : null}
      </Flex>
      <h1>{data?.title}</h1>
      {!video ? <>{getWrittenOnText(selctedLanguage)}</> : null}
    </ArticleDetailSection>
  );
}
